// extracted by mini-css-extract-plugin
export default {"tooltip":"SubChart_tooltip__wwq+v","sum":"SubChart_sum__p2XUA","tooltipHr":"SubChart_tooltipHr__cLspR","graphName":"SubChart_graphName__4ttYV"};